/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {Row, Col, Box} from 'adminlte-2-react';
import {Alert} from '../utils/Alert';
import {log} from '../utils/logs';
import {ButtonWithLoading} from '../utils/ButtonWithLoading';
import Loader from '../utils/Loader';
import {Content} from '../ui/Content';
import {alertTypes} from '../ui/alert';
const {TextInput} = require('../utils/TextInput');

export const ParametroEditView = ({
  history,
  parametroGet,
  parametroEdit,
  submit,
  submitAlert,
  topAlert,
  concepto,
  setConcepto,
  periodo,
  setPeriodo,
  valor,
  setValor,
  primeraEscala,
  setPrimeraEscala,
  segundaEscala,
  setSegundaEscala,
}) => {
  const title = 'Editar parámetro';

  return (
    <Content title={title} history={history}>
      {topAlert.text && (
        <Alert
          title={topAlert.title}
          type={topAlert.type}
          text={topAlert.text}
          closable={topAlert.closable}
        />
      )}

      <Loader isLoading={parametroGet?.loading}>
        <Row>
          <Col md="10" mdOffset="1">
            <Box title="Datos del equipo">
              <Row>
                <Col md="12">
                  <Col md="12">
                    <TextInput
                      label="Concepto"
                      initialValue={concepto}
                      setValue={setConcepto}
                      required
                      disabled
                    />

                    <TextInput
                      label="Periodo"
                      initialValue={periodo}
                      setValue={setPeriodo}
                      required
                      disabled
                    />

                    <TextInput
                      label="Rendimiento esperado"
                      initialValue={valor}
                      setValue={setValor}
                      required
                    />

                    <TextInput
                      label="Porcentaje mínimo de rendimiento aceptable"
                      help="Si la producción del selector es menor, se pintará de rojo."
                      initialValue={primeraEscala}
                      setValue={setPrimeraEscala}
                      required
                    />

                    <TextInput
                      label="Porcentaje mínimo de rendimiento óptimo"
                      help="Si la producción del selector es menor, se pintará de amarillo. Si es mayor, de verde."
                      initialValue={segundaEscala}
                      setValue={setSegundaEscala}
                      required
                    />
                  </Col>
                </Col>

                <Col md="12">
                  {submitAlert.text && (
                    <Alert
                      title={submitAlert.title}
                      type={submitAlert.type}
                      text={submitAlert.text}
                      closable={submitAlert.closable}
                    />
                  )}
                  <ButtonWithLoading
                    text="Guardar"
                    submit={submit}
                    loading={parametroEdit.loading}
                    pullRight
                  />
                </Col>
              </Row>
            </Box>
          </Col>
        </Row>
      </Loader>
    </Content>
  );
};
